import { observable, reaction } from 'mobx';
import get from 'lodash/get';
import { fetchItem } from '../core/storage';

// TODO - Revisar que se puede eliminar y que se puede mantener y agregar
export const appStore = observable({
	isReady: false,
	isOnline: false,
	offLineState: false,
	wasPlaying: false,
	currentSong: null,
	sessionToken: !!fetchItem('APP_TOKEN_SESSION'),
	currentMusicChannel: null,
	sessionExpiredMessage: false,
	forceLogout: null,
	storeName: get(fetchItem('STORE_INFO'), 'storeName', ''),
	newUpdateAvailable: false,
	newUpdateDownloaded: false,
	initialStart: false,
	waitingForPlay: null,
	errorStarting: false,
	loadingJukeBox: false,
	deviceId: 'web'
});

reaction(
	() => appStore.isReady,
	(isReady) => { }
);
reaction(
	() => appStore.isOnline,
	(isOnline) => { }
);
reaction(
	() => appStore.offLineState,
	(offLineState) => { }
);
reaction(
	() => appStore.currentSong,
	(currentSong) => { }
);
reaction(
	() => appStore.isSlowConnection,
	(isSlowConnection) => { }
);
reaction(
	() => appStore.wasPlaying,
	(wasPlaying) => { }
);
reaction(
	() => appStore.sessionToken,
	(sessionToken) => { }
);
reaction(
	() => appStore.currentMusicChannel,
	(currentMusicChannel) => { }
);
reaction(
	() => appStore.sessionExpiredMessage,
	(sessionExpiredMessage) => { }
);
reaction(
	() => appStore.storeName,
	(storeName) => { }
);
reaction(
	() => appStore.newUpdateAvailable,
	(newUpdateAvailable) => { }
);
reaction(
	() => appStore.newUpdateDownloaded,
	(newUpdateDownloaded) => { }
);
reaction(
	() => appStore.initialStart,
	(initialStart) => { }
);
reaction(
	() => appStore.waitingForPlay,
	(waitingForPlay) => { }
);
reaction(
	() => appStore.errorStarting,
	(errorStarting) => { }
);
// TODO: CHECAR SI ESTE APP STORE.DEVICEID SE MANTIENE
reaction(
	() => appStore.deviceId,
	(deviceId) => { }
);
reaction(
	() => appStore.loadingJukeBox,
	(loadingJukeBox) => { }
);
